import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const displayCategories = categories.filter(c => c.slug !== 'all');

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            视频分类
          </h2>
          <p className="text-foreground-500 mt-2 text-sm md:text-base">
            海量内容随心选，总有一个频道适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {displayCategories.map(cat => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer text-center"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">
                {cat.videoCount}个视频
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-full border border-primary-300 text-primary-600 hover:bg-primary-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览全部频道
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}